import { useEffect } from 'react';
import { Container } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import userApi from 'services/api/user';
import { locations } from 'services/routes/locations';

const EmailConfirmation = () => {
  const navigate = useNavigate();

  const { emailConfirmationToken } = useParams();

  const [confirmEmail, { isSuccess, isError }] =
    userApi.useConfirmEmailMutation();

  useEffect(() => {
    if (!emailConfirmationToken) {
      return;
    }
    confirmEmail(emailConfirmationToken);
  }, [emailConfirmationToken, confirmEmail]);

  useEffect(() => {
    if (isSuccess) {
      navigate(locations.general.aiMusicGenerator.pathname, {
        state: { showEmailConfirmationDialog: true },
      });
      return;
    }
    if (isError) {
      navigate(locations.general.aiMusicGenerator.pathname);
    }
  }, [isSuccess, isError, navigate]);

  return <Container />;
};

export default EmailConfirmation;
